let openModalCount = 0;

export function addModalOpen() {
  if(document.querySelectorAll(".success-modal-container").length === 0) {
    openModalCount = 0;
  }
  openModalCount++;
  document.querySelector("body").classList.add("modal-open");
}

export function removeModalOpen() {
  openModalCount = Math.max(0, openModalCount - 1);

  if(openModalCount === 0) {
    document.querySelector("body").classList.remove("modal-open");
  }
}
